import { LoaderFunctionArgs, redirect } from "react-router-dom";
import { myAxios } from "src/components/common/functions";
import { appendField } from "../common/FilterFrame/FilterField";
import { buildDefaultState } from "../common/FilterFrame/FilterModal";
import { fields } from "./filter";
import type { ReportRecord } from "./types";

export const reportExtraFields = ["page", "limit", "approval"];

type ReportsLoaderData = {
    reports: ReportRecord[];
    total: number;
};

export async function reportsLoader({ request }: LoaderFunctionArgs) {
    const url = new URL(request.url);
    const pageParam = url.searchParams.get("page");
    const limitParam = url.searchParams.get("limit");
    let shouldRedirect = false;

    for (const [key] of url.searchParams) {
        if (![...Object.keys(buildDefaultState(fields)), ...reportExtraFields].includes(key)) {
            url.searchParams.delete(key);
            shouldRedirect = true;
        }
    }
    if (!pageParam) {
        url.searchParams.set("page", "1");
        shouldRedirect = true;
    }
    if (!limitParam) {
        url.searchParams.set("limit", "10");
        shouldRedirect = true;
    }
    if (shouldRedirect) throw redirect(url.pathname + "?" + url.searchParams.toString());

    const fd = new FormData();
    fd.append("page", url.searchParams.get("page")!);
    fd.append("limit", url.searchParams.get("limit")!);
    for (const field of fields) {
        appendField(fd, url.searchParams, field);
    }

    const res = await myAxios({ fileName: "reports/readReports.php", formData: fd });
    if (!res) throw redirect("..");
    const data = res.data as ReportsLoaderData | ReportRecord[];
    if (Array.isArray(data)) {
        return {
            reports: data,
            total: data.length,
        };
    }
    return {
        reports: data.reports ?? [],
        total: data.total ?? data.reports?.length ?? 0,
    };
}

export async function reportLoader({ params }: LoaderFunctionArgs) {
    const { id } = params;
    if (!id) throw redirect("/Reports");
    const fd = new FormData();
    fd.append("id", id);
    const res = await myAxios({ fileName: "reports/readReport.php", formData: fd });
    if (!res) throw redirect("/Reports");
    const report = (res.data as { report?: ReportRecord }).report;
    if (!report) throw redirect("/Reports");
    return {
        report,
    };
}
